<template>
  <div class="section-background">
    <success-snackbar
      v-if="showSuccessSnackbar"
      :snackbarText="snackbarText"
      @hidde="showSuccessSnackbar = false"
    />
    <v-row no-gutters align="center">
      <h3 class="section-name">Послуги</h3>
      <v-row no-gutters align="center" justify="end">
        <admin-submit-button @click="showCreateServiceModal = true"
          ><v-icon color="#FFFFFF" style="margin-right: 4px" size="22px"
            >mdi-plus</v-icon
          >Додати послугу</admin-submit-button
        >
      </v-row>
    </v-row>
    <loader v-if="showLoader" />
    <div
      style="
        height: 200px;
        display: grid;
        place-items: center;
        margin-top: 16px;
      "
      v-else-if="services.length === 0"
    >
      <p style="margin: 0px">Жодної послуги не було додано</p>
    </div>
    <div style="margin-top: 30px" v-else>
      <service-card
        v-for="service in services"
        :key="service.id"
        @setItemForEdit="setItemForEdit"
        @deleteService="deleteService"
        :service="service"
      />
    </div>

    <create-service-modal
      v-if="showCreateServiceModal"
      :visible="showCreateServiceModal"
      :itemForEdit="itemForEdit"
      :isEdit="isEdit"
      @success="success"
      @close="(showCreateServiceModal = false), (isEdit = false)"
    />
  </div>
</template>

<script>
import servicesService from "../../../requests/Admin/servicesService";
import adminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import Loader from "../../UI/Loader.vue";
import SuccessSnackbar from "../../UI/Snackbars/successSnackbar.vue";
import CreateServiceModal from "./createServiceModal.vue";
import ServiceCard from "./serviceCard.vue";
export default {
  components: {
    adminSubmitButton,
    CreateServiceModal,
    SuccessSnackbar,
    ServiceCard,
    Loader,
  },
  data: () => ({
    services: [],
    showCreateServiceModal: false,
    showSuccessSnackbar: false,
    showLoader: true,
    isEdit: false,
    itemForEdit: {},
    snackbarText: "",
  }),
  mounted() {
    this.getServices();
  },
  methods: {
    async getServices() {
      await servicesService.getServices().then((res) => {
        this.services = res;
        this.showLoader = false;
      });
    },
    async deleteService(id) {
      await servicesService.deleteService(id).then(() => {
        this.showLoader = true;
        this.getServices();
      });
    },
    success(snackbarText) {
      this.showCreateServiceModal = false;
      this.showSuccessSnackbar = true;
      this.snackbarText = snackbarText;
      this.showLoader = true;
      this.getServices();
    },
    setItemForEdit(item) {
      this.itemForEdit = { ...item, image: { path: item.photo } };
      this.isEdit = true;
      this.showCreateServiceModal = true;
    },
  },
};
</script>

<style>
</style>